'use strict';

/**
 * @author Maxim Seredkin
 */
export default ['$rootScope', '$log',
    function ($rootScope, $log) {
        $rootScope.title = "Справка";
    }]
